import React from "react";
import { nanoid } from "nanoid";
import styled from "styled-components";
import PropTypes from "prop-types";

const ToolTipContainer = styled.div`
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  display: ${({ visible }) => (visible ? "block" : "none")};
  background-color: #b1b1b1;
  color: rgba(0, 0, 0, 0.7);
  text-align: left;
  padding: 02;
  border: 1px solid #b1b1b1;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  font-size: 12px;
  height: auto;
  width: auto;
  max-width: 80vw;
  min-width: 40vw;
  max-height: 60vh;
  min-height: 30vn;
`;

const Row = styled.div`
  background-color: ${({ type }) =>
    type === "header" ? "#eeeeee" : "#ffffff"};
  display: flex;
  flex-wrap: wrap;
  padding: 4px;
`;
const Cell = styled.div``;

export default function ToolTip(props) {
  const { words, score, visible } = props;

  return (
    <ToolTipContainer visible={visible}>
      <Row type="header">
        <Cell>
          <strong>Sentiment Details</strong>
        </Cell>
      </Row>
      <Row>
        <Cell>
          <strong>Score</strong>:&nbsp;
        </Cell>
        <Cell>{score}</Cell>
      </Row>
      <Row>
        <Cell>
          <strong>Positive:&nbsp;</strong>
        </Cell>
        {words.positive &&
          Object.entries(words.positive).map(([key, value]) => (
            <Cell key={nanoid()}>
              {key}:&nbsp;({value}),
            </Cell>
          ))}
      </Row>
      <Row>
        <Cell>
          <strong>Negative:&nbsp;</strong>
        </Cell>
        {words.negative &&
          Object.entries(words.negative).map(([key, value]) => (
            <Cell key={nanoid()}>
              {key}: {value},&nbsp;
            </Cell>
          ))}
      </Row>
    </ToolTipContainer>
  );
}

ToolTip.propTypes = {
  words: PropTypes.PropTypes.shape({
    positive: PropTypes.object,
    negative: PropTypes.object,
  }),
  score: PropTypes.number,
  visible: PropTypes.bool,
};

ToolTip.defaultProps = {
  words: {},
  score: 0,
  visible: false,
};
